import cidades from '@/store/cidades'
import bancos from '@/store/bancos'
export default {
  estados: [
    {sigla: 'AC', value: 'Acre'},
    {sigla: 'AL', value: 'Alagoas'},
    {sigla: 'AM', value: 'Amazonas'},
    {sigla: 'AP', value: 'Amapá'},
    {sigla: 'BA', value: 'Bahia'},
    {sigla: 'CE', value: 'Ceará'},
    {sigla: 'DF', value: 'Distrito Federal'},
    {sigla: 'ES', value: 'Espírito Santo'},
    {sigla: 'GO', value: 'Goiás'},
    {sigla: 'MA', value: 'Maranhão'},
    {sigla: 'MG', value: 'Minas Gerais'},
    {sigla: 'MS', value: 'Mato Grosso do Sul'},
    {sigla: 'MT', value: 'Mato Grosso'},
    {sigla: 'PA', value: 'Pará'},
    {sigla: 'PB', value: 'Paraíba'},
    {sigla: 'PE', value: 'Pernambuco'},
    {sigla: 'PI', value: 'Piauí'},
    {sigla: 'PR', value: 'Paraná'},
    {sigla: 'RJ', value: 'Rio de Janeiro'},
    {sigla: 'RN', value: 'Rio Grande do Norte'},
    {sigla: 'RO', value: 'Rondônia'},
    {sigla: 'RR', value: 'Roraima'},
    {sigla: 'RS', value: 'Rio Grande do Sul'},
    {sigla: 'SC', value: 'Santa Catarina'},
    {sigla: 'SE', value: 'Sergipe'},
    {sigla: 'SP', value: 'São Paulo'},
    {sigla: 'TO', value: 'Tocantins'}
  ],
  sexos: [
    {label: 'Masculino', value: 'MASCULINO'},
    {label: 'Feminino', value: 'FEMININO'},
    {label: 'Não declarado', value: 'NAO_DECLARADO'}
  ],
  paises: [
    {
      ordem: 31,
      nome: 'Brasil',
      sigla2: 'BR',
      sigla3: 'BRA',
      codigo: '076'
    }
  ],
  ...cidades,
  ...bancos
}



// WEBPACK FOOTER //
// ./src/store/state.js